export default __webpack_public_path__ + "static/media/xboxdifferences.40031079.png";